import Vue from 'vue';
import Router from 'vue-router';
import Layout from './views/Layout.vue';
import HomePage from './views/HomePage.vue';
import SongPage from './views/SongPage.vue';
import PrintSongPage from './views/PrintSongPage.vue';
import LoginPage from './views/LoginPage.vue';
import SongsListPage from './views/SongsListPage.vue';
import VersionsPage from './views/VersionsPage.vue';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path:      '/print-song',
            name:      'print-song',
            component: PrintSongPage,
        },
        {
            path:      '/',
            component: Layout,
            children:  [
                {
                    path:      '/',
                    name:      'home',
                    component: HomePage,
                },
                {
                    path:      '/login',
                    name:      'login',
                    component: LoginPage,
                },
                {
                    path:      '/new-song',
                    name:      'new-song',
                    component: SongPage,
                },
                {
                    path:      '/edit-song/:id',
                    name:      'edit-song',
                    component: SongPage,
                },
                {
                    path:      '/songs-list',
                    name:      'songs-list',
                    component: SongsListPage,
                },
                {
                    path:      '/about',
                    name:      'about',
                    component: () => import(/* webpackChunkName: "about" */ './views/AboutPage.vue'),
                },
                {
                    path:      '/versions',
                    name:      'versions',
                    component: VersionsPage,
                },
            ],
        },
    ],
});
